module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl1_m_en.024f687da41ff59db114b28638cae9d9.png";